import mapaDeRotas from "@/router/caminho-urls";
import axios from 'axios';

export async function salvarCadastro(dados) {
    try {
        const rota = new mapaDeRotas();
        const formData = new FormData();

        for (const key in dados) {
            formData.append(key, dados[key]);
        }

        const config = {
            url: `${rota.rota_api}/usuario/cadastrar-usuario`,
            method: "post",
            headers: {
                "content-Type": "multipart/form-data",
            },
            data: formData
        };
        const requisicao = await axios(config)
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err)
                return err
            });
        return requisicao;
    } catch (error) {
        console.error(error.status);
        throw error;
    }
}